module.exports = __webpack_public_path__ + "static/img/kaishu_benefit_detail3.8894db0d.jpg";